const enum AttributeVoActionType {
  SET_MENU_VO_LIST = 'SET_MENU_VO_LIST',
  SET_ATTRIBUTE_VO_ITEMVO = 'SET_ATTRIBUTE_VO_ITEMVO',
  SET_ATTRIBUTE_VO_QUANTITY = 'SET_ATTRIBUTE_VO_QUANTITY',
  SET_ATTRIBUTE_VO_DISPLAY_ATTRIBUTES = 'SET_ATTRIBUTE_VO_DISPLAY_ATTRIBUTES',
  SET_ATTRIBUTE_VO_ITEM_COMMENT = 'SET_ATTRIBUTE_VO_ITEM_COMMENT',
  SET_ATTRIBUTE_VO_SECOND_ITEMVOINFO = 'SET_ATTRIBUTE_VO_SECOND_ITEMVOINFO',
  SET_ATTRIBUTE_VO_DISPLAY_SECOND_ATTRIBUTES = 'SET_ATTRIBUTE_VO_DISPLAY_SECOND_ATTRIBUTES',
  SET_ATTRIBUTE_VO_SELECTED_ATTRIBUTES = 'SET_ATTRIBUTE_VO_SELECTED_ATTRIBUTES',
  SET_ATTRIBUTE_VO_SELECTED_ORDERITEMS = 'SET_ATTRIBUTE_VO_SELECTED_ORDERITEMS',
  SET_ATTRIBUTE_VO_SELECTED_SECOND_ATTRIBUTE = 'SET_ATTRIBUTE_VO_SELECTED_SECOND_ATTRIBUTE',
  SET_ATTRIBUTE_VO_MIN_SELECTION_ALERTS = 'SET_ATTRIBUTE_VO_MIN_SELECTION_ALERTS',
  SET_ATTRIBUTE_VO_CART_ITEM_VOUUIDS = 'SET_ATTRIBUTE_VO_CART_ITEM_VOUUIDS',
  SET_ATTRIBUTE_VO_RESET = 'SET_ATTRIBUTE_VO_RESET',
}

export { AttributeVoActionType };
